import { createContext, useState } from "react";

const FContext = createContext({
    formData: {},
    pushInfo: () => {},
    authentic: "", 
    authen: () => {}
})

export const FormContextProvider = (props) => {
    const [formData, setFormData] = useState({})
    const [authentic, setAuthentic] = useState(true);

    const pushInfoHandler = (val) => {
        setAuthentic(true);

        return setFormData(prev => {
            return {
                ...prev,
                val
            }
        });
        
    }

    const Context = {
        pushInfo: pushInfoHandler,
        // authen: changeAuthenticHandler,
        formData: formData,
        authentic: authentic
    }

    return <FContext.Provider value={Context}>
        {props.children}
    </FContext.Provider>
}

export default FContext;